interface Props {
  role: 'admin' | 'billing' | 'tech';
}

const roleConfig = {
  admin: {
    label: 'Admin',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  billing: {
    label: 'Billing',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  tech: {
    label: 'Tech',
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  },
};

export default function RoleBadge({ role }: Props) {
  const config = roleConfig[role];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}
    >
      {config.label}
    </span>
  );
}
